import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { FileUploadI } from "../utils";

export const putEnderecoAutonomo = async (params: {
  idAutonomo: string;
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  arquivo: FileUploadI | null;
  authToken: string;
}): Promise<any> => {
  const url = "/api/autonomo/SolicitaAlteracaoEnderecoAutonomo";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, parameters, config);
  return response?.data;
};
